module.exports = __webpack_public_path__ + "static/media/sample_vehicle_details_hub.d7889a29.csv";